/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodDrinkCupStrawIcon20Regular = forwardRef('FoodDrinkCupStrawIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.54 2.133a.75.75 0 0 1 .742-.633H16A.75.75 0 0 0 16 0h-3.718a2.25 2.25 0 0 0-2.223 1.9L9.57 5H5.346a1.5 1.5 0 0 0-1.489 1.679L5.07 16.798A2.5 2.5 0 0 0 7.553 19h4.894a2.5 2.5 0 0 0 2.483-2.202l1.214-10.12A1.5 1.5 0 0 0 14.654 5h-3.566l.453-2.867ZM5.346 6.5h9.31L13.44 16.62a1 1 0 0 1-.993.88H7.553a1 1 0 0 1-.993-.88L5.345 6.5Z" })));
});
